<template>
  <div>
    <div class="fixed-content">
      <div class="flex gap-20">
        <button class="btn btn-primary" @click="$emit('handleClickAdd')">
          {{ textBtnAdd }}
          <i class="fa fa-cube fa-lg mr-l-5" aria-hidden="true"></i>
        </button>
        <button class="btn btn-primary" @click="$emit('handleClickRegister')">
          {{ textBtnRegister }}
          <i class="fa fa-check fa-lg mr-l-5" aria-hidden="true"></i>
        </button>
    </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    textBtnAdd: {
      type: String,
      default: '商品選択'
    },
    textBtnRegister: {
      type: String,
      default: '商品選択'
    }
  }
}
</script>

<style scoped>
.fixed-content {
  position: fixed;
  top: 60px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  background: rgba(255, 102, 0, 0.3);
  padding: 10px;
  z-index: 1000;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseAcross/components/FixedHeader.vue